import { render } from "./CallsTracking.vue?vue&type=template&id=db0346a2&scoped=true"
import script from "./CallsTracking.vue?vue&type=script&lang=js"
export * from "./CallsTracking.vue?vue&type=script&lang=js"

import "./CallsTracking.vue?vue&type=style&index=0&id=db0346a2&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\Leads\\leads-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db0346a2"]])

export default __exports__